import { logWebVitals } from './utils/performanceUtils';

const reportWebVitals = (onPerfEntry) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  } else {
    // Default: log to console/analytics
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(logWebVitals);
      getFID(logWebVitals);
      getFCP(logWebVitals);
      getLCP(logWebVitals);
      getTTFB(logWebVitals);
    });
  }
};

export default reportWebVitals;
